import type { UserGroupSyncStatus } from '@frameio/graphql-client/generated';

const SYNCING_STATUSES = ['IN_PROGRESS', 'NOT_STARTED'];

export function adobeManagedGroupIsSyncing(
  syncStatus?: UserGroupSyncStatus | null
): boolean {
  return !!syncStatus && SYNCING_STATUSES.includes(syncStatus);
}
